import { render, staticRenderFns } from "./Updater.vue?vue&type=template&id=4124997c&scoped=true&"
import script from "./Updater.vue?vue&type=script&lang=js&"
export * from "./Updater.vue?vue&type=script&lang=js&"
import style0 from "./Updater.vue?vue&type=style&index=0&id=4124997c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4124997c",
  null
  
)

export default component.exports